import { render, staticRenderFns } from "./PRJ912P01.vue?vue&type=template&id=b2bd5eac&"
import script from "./PRJ912P01.vue?vue&type=script&lang=js&"
export * from "./PRJ912P01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports